// pages/sitetop.tsx

import { NextPage } from 'next';

import { SiteTopProps, SiteTopTemplate } from '@/features/siteTop/template/SiteTopTemplate';

const SiteTop: NextPage<SiteTopProps> = () => <SiteTopTemplate />;

export default SiteTop;
